import gql from "graphql-tag";

export const addorEditUser = gql`
  mutation UsersdataCreate($obj: JSON) {
    UsersdataCreate(data: $obj) {
      id
    }
  }
`;

export const updateUser = gql`
  mutation UsersdataUpsertWithWhere($id: JSON, $data: JSON) {
    UsersdataUpsertWithWhere(where: $id, data: $data) {
      id
    }
  }
`;

export const updatePassword = gql`
  mutation UsersdataSetPassword($id: JSON, $newPassword: String) {
    UsersdataSetPassword(id: $id, newPassword: $newPassword)
  }
`;
